import { Card } from '@ipfabric/ui-components/Card/Card';
import { Table } from 'components/Table/components/Table';
import { renderQuery } from 'utils/react-query/renderQuery';
import { RoleFormPanel } from './RoleFormPanel';
import { useRolesTableV2 } from './useRolesTableV2';

const description =
  'Roles combine endpoint policies (which API endpoints may be called) and ' +
  'data policies (which rows may be seen). Assign roles to users and API tokens.';

export const RolesPageV2 = () => {
  const table = useRolesTableV2();

  return (
    <div className='flex min-h-0 flex-1 flex-col p'>
      <Card className='flex min-h-0 flex-1 flex-col' noShadow>
        {renderQuery({
          query: table.rolesQuery,
          renderStaleDataOnMount: true,
          success: () => (
            <Table
              borderless
              className='flex-1 bg-transparent'
              columns={table.columns}
              description={description}
              disableTableRowDetail
              id='settings-administration-roles-v2'
              loadRowIdsForSelectAll='fromData'
              menuItems={table.menuItems}
              rowHeight={44}
              rowIdField='id'
              title='List of roles'
              {...table.frontendSimpleFilter}
            />
          ),
        })}
      </Card>
      {table.confirmDeleteDialog.render()}
      {table.opened && (
        <RoleFormPanel
          mode={table.opened.mode}
          roleId={table.opened.roleId}
          onClose={() => table.setOpened(null)}
        />
      )}
    </div>
  );
};
